import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
//Import cross icon
import CloseIcon from '@mui/icons-material/Close';
import {getPDFView} from '../../../services/ordersServices'
import './style.css'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  height:'80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



export default function InvoicesModal({instance,accounts,invoiceNumber,button,userID}) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [pdf, setPdf] = useState()
  const handleOpenClick = () => {
    setOpen(true)

  }

const getInvoicesDocument = () => {
  getPDFView(instance,accounts,invoiceNumber,userID).then((res) => {
  setPdf(`${res}#zoom=125` );}
)}


  return (
    <>
    <div>
    
     
      <IconButton
        aria-label='delete'
        size='small'
        onClick={() => {handleOpenClick();
          getInvoicesDocument()}}
      >
        {button}
      </IconButton>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <CloseIcon
        fontSize='large'
        sx={{ position: 'absolute', top: 0, right: 0, color: 'grey', cursor: 'pointer' }}
            
          /> 
          <object data={`${pdf}`} type="application/pdf" width="100%" height="100%" >
                         
          </object>
        
        </Box>
      </Modal>
    </div>
    </>
  );
}
